import { useContext, useMemo } from "react";
import { useQueryClient } from "react-query";

import ModalsManagerContext from "contexts/ModalsManager";
import { IPackage } from "dto/IPackage";
import { IPendingReceptionItem } from "dto/Mailroom/IDispatchChart";
import ReceptionModal from "modules/biuroPodawczeModule/ReceptionModal";

/**
 * Zadanie 4 — rejestracja zwrotki ZPO / odbioru dla POJEDYNCZEJ wysłanej przesyłki
 * z poziomu listy przesyłek użytkownika (OptionsCard). Czyta przesyłkę z
 * localStorage("package") i otwiera tę samą formatkę co podlista „Zwrotki ZPO".
 */
const RegisterReceptionModal = () => {
  const { modals, setModals } = useContext(ModalsManagerContext);
  const queryClient = useQueryClient();

  const pack = useMemo<IPackage | null>(() => {
    try {
      const raw = localStorage.getItem("package");
      return raw ? (JSON.parse(raw) as IPackage) : null;
    } catch {
      return null;
    }
  }, []);

  const item = useMemo<IPendingReceptionItem | null>(() => {
    if (!pack) return null;
    const r = pack.Receivers?.[0];
    const receiverName =
      [r?.Name, r?.Surname].filter(Boolean).join(" ").trim() ||
      r?.CompanyName ||
      pack.Sender ||
      null;
    return {
      Id: pack.Id,
      ParcelNumber: pack.ParcelNumber ?? null,
      Title: pack.S1?.replace(/<\/?em>/g, "") ?? null,
      ReceiverName: receiverName,
    };
  }, [pack]);

  const close = () => setModals({ ...modals, registerReception: false });

  // Montowany tylko po zapisie localStorage("package") — brak danych to stan
  // zdegenerowany; renderujemy pusto (bez setState w renderze).
  if (!item) return null;

  return (
    <ReceptionModal
      item={item}
      onClose={close}
      onDone={() => {
        queryClient.invalidateQueries("packages");
        close();
      }}
    />
  );
};

export default RegisterReceptionModal;
